import styled from '@emotion/styled'
import {COLORS} from '../constants'

/** Right-aligned bar holding the Expand all / Collapse all buttons above the tree. */
export const Controls = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`

/** A single tree-wide control; a compact outlined button that matches the muted tree chrome. */
export const ControlButton = styled.button`
  cursor: pointer;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  color: ${COLORS.foreground};
  background-color: ${COLORS.cardBg};
  border: 1px solid ${COLORS.border};
  border-radius: 8px;

  &:hover {
    background-color: ${COLORS.mutedBg};
    border-color: ${COLORS.brand};
    color: ${COLORS.brand};
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.brand};
    outline-offset: 2px;
  }
`
